<template>
  <section class="fomo-dashboard-card collection-summary" :aria-label="eventId ? 'Recaudación en puntos de venta' : 'Neto mensual del organizador'">
    <div class="collection-summary__header">
      <div><span class="collection-summary__eyebrow">{{ eventId ? 'Puntos de venta' : 'Todos tus eventos' }}</span><h2>{{ eventId ? 'Efectivo y POS recaudado' : 'Tu neto del mes' }}</h2><p>{{ eventId ? 'Cobros confirmados. Las devoluciones se muestran por separado.' : 'Ventas confirmadas después de la comisión de Fomo, antes de egresos. Cada moneda se muestra por separado.' }}</p></div>
      <div class="collection-summary__filter">
        <label v-if="eventId">Fecha de recaudación<input v-model="day" type="date" @change="load" /></label>
        <label v-else>Mes<input v-model="month" type="month" required @change="load" /></label>
        <FomoButton :disabled="loading" :icon="'fas fa-rotate'" @click="load">Actualizar</FomoButton>
      </div>
    </div>
    <p v-if="error" role="alert">{{ error }}</p>
    <p v-else-if="loading" role="status">Cargando recaudación…</p>
    <p v-else-if="!groups.length">{{ eventId ? 'Todavía no hay cobros de caja' + (day ? ' en esta fecha.' : '.') : 'No hay ventas confirmadas en este mes.' }}</p>
    <p v-if="testMode">Evento de demostración: estos importes no forman parte de la contabilidad real ni del neto global.</p>
    <div v-for="group in groups" :key="group.currency + group.funds_recipient" class="collection-summary__group">
      <template v-if="eventId">
        <strong>{{ group.currency }} · Recibe {{ group.funds_recipient === 'fomo' ? 'Fomo' : 'el organizador' }}</strong>
        <dl><div><dt>Efectivo recaudado</dt><dd>{{ money(group.cash, group.currency) }}</dd></div><div><dt>POS recaudado</dt><dd>{{ money(group.pos, group.currency) }}</dd></div><div><dt>Devuelto</dt><dd>{{ money(group.refunded, group.currency) }}</dd></div></dl>
        <p>Neto del organizador por estas ventas: {{ money(group.organizer_net, group.currency) }}</p>
      </template>
      <template v-else>
        <span class="collection-summary__eyebrow">Neto por ventas · {{ group.currency }}</span><strong class="collection-summary__earned">{{ money(group.organizer_net, group.currency) }}</strong>
        <dl><div><dt>De efectivo en cajas</dt><dd>{{ money(group.cash, group.currency) }}</dd></div><div><dt>De POS en cajas</dt><dd>{{ money(group.pos, group.currency) }}</dd></div><div><dt>De otras ventas</dt><dd>{{ money(group.online, group.currency) }}</dd></div></dl>
      </template>
    </div>
    <p class="collection-summary__note">{{ eventId ? 'Estos cobros no incrementan el saldo disponible para transferencias. El efectivo y el terminal POS requieren conciliación de tesorería.' : 'El neto por ventas no equivale al saldo disponible para transferencias. Los cobros físicos requieren conciliación.' }}</p>
  </section>
</template>
<script>
import FomoButton from '../ui/FomoButton.vue'
import { cashierApi } from '../../common/cashier.js'
import { formatCurrencyAmount } from '../../common/currency.js'
import '../../styles/fomo-dashboard.css'

export default {
  name: 'CashierCollectionSummary', components: { FomoButton },
  props: { eventId: { type: [Number, String], default: null } },
  data: () => ({ groups: [], testMode: false, day: '', month: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`, error: '', loading: false, requestId: 0 }),
  watch: { eventId: { immediate: true, handler() { this.load() } } },
  methods: {
    money: formatCurrencyAmount,
    async load() {
      const id = ++this.requestId
      this.loading = true
      this.error = ''
      this.groups = []
      try {
        const params = new URLSearchParams()
        if (this.eventId) params.set('event', this.eventId)
        if (this.eventId && this.day) params.set('date', this.day)
        if (!this.eventId) params.set('month', this.month)
        const result = await cashierApi(`${this.eventId ? 'collections' : 'earnings'}/?${params}`)
        if (id === this.requestId) { this.groups = result.groups; this.testMode = !!result.test_mode }
      } catch (error) { if (id === this.requestId) this.error = error.message }
      finally { if (id === this.requestId) this.loading = false }
    },
  },
}
</script>
<style scoped>
.collection-summary { padding: 24px; display: grid; gap: 18px; color: #eef4ff; font-family: var(--fomo-font-body); }
.collection-summary__header { display: flex; align-items: start; justify-content: space-between; gap: 16px; flex-wrap: wrap; }
.collection-summary h2 { font: 700 24px/1.25 var(--fomo-font-heading); margin: 6px 0; }
.collection-summary p { font: 13px/1.6 var(--fomo-font-body); margin: 0; color: #b8c0d2; }
.collection-summary__eyebrow { font: 12px var(--fomo-font-label); text-transform: uppercase; letter-spacing: .1em; }
.collection-summary__filter { display: flex; gap: 12px; align-items: end; flex-wrap: wrap; }
.collection-summary label { display: grid; gap: 6px; font-size: 12px; }
.collection-summary input { color-scheme: dark; padding: 10px; color: inherit; background: var(--fomo-control); border: 1px solid rgba(196,206,228,.2); border-radius: 12px; }
.collection-summary__group { border-top: 1px solid rgba(196,206,228,.12); padding-top: 16px; }
.collection-summary__earned { display: block; font: 700 36px/1.2 var(--fomo-font-heading); margin-top: 8px; overflow-wrap: anywhere; }
.collection-summary dl { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 14px; margin: 14px 0 0; }
.collection-summary dt { font-size: 12px; color: #b8c0d2; }
.collection-summary dd { font: 700 24px var(--fomo-font-heading); margin: 8px 0 0; overflow-wrap: anywhere; }
@media(max-width:640px) { .collection-summary { padding: 18px; } .collection-summary dl { grid-template-columns: 1fr; } }
</style>
